<template>
    <div class="mt-6 bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">{{ $t('Add User') }}</h3>
            <div class="mt-2 max-w-xl text-sm text-gray-500">
                <p>{{ $t('To add a new user to the workspace, search for the user\'s name in the list and add them to the workspace.') }}</p>
            </div>
            <div class="w-full mt-5 flex items-center space-x-6">
                <div class="flex-grow">
                    <Combobox as="div" v-model="selectedPerson">
                        <div class="relative">
                            <ComboboxInput
                                class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm"
                                @change="query = $event.target.value" :display-value="(person) => person?.name" :placeholder="$t('Search user')"/>
                            <ComboboxButton
                                class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
                            </ComboboxButton>

                            <ComboboxOptions v-if="filteredPeople.length > 0"
                                             class="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                <ComboboxOption v-for="person in filteredPeople" :key="person.id" :value="person" as="template"
                                                v-slot="{ active, selected }">
                                    <li :class="['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-primary-600 text-white' : 'text-gray-900']">
                                        <div class="flex items-center">
                                            <img :src="person.profile_photo_url" alt=""
                                                 class="h-6 w-6 flex-shrink-0 rounded-full"/>
                                            <span :class="['ml-3 truncate', selected && 'font-semibold']">
                {{ person.name }} ({{ person.email}})
              </span>
                                        </div>

                                        <span v-if="selected"
                                              :class="['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-indigo-600']">
              <CheckIcon class="h-5 w-5" aria-hidden="true"/>
            </span>
                                    </li>
                                </ComboboxOption>
                            </ComboboxOptions>
                        </div>
                    </Combobox>
                </div>
                <div class="flex space-x-3" v-if="selectedPerson && selectedPerson.id">
                    <JetSecondaryButton :class="{ 'opacity-25': isProcessing }" :disabled="isProcessing" @click="selectedPerson = {}">
                        {{ $t('Cancel') }}
                    </JetSecondaryButton>
                    <JetButton :class="{ 'opacity-25': isProcessing }" :disabled="isProcessing" @click="attachUser">
                        {{ $t('Add') }}
                    </JetButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {CheckIcon, SelectorIcon} from '@heroicons/vue/solid'
</script>

<script>
import {Link} from "@inertiajs/vue3";
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions,
} from '@headlessui/vue'
import {defineComponent} from "vue";

export default defineComponent({
    name: "UserAttachForm",
    components: {
        Link,
        Combobox,
        ComboboxButton,
        ComboboxInput,
        ComboboxLabel,
        ComboboxOption,
        ComboboxOptions,
        JetButton,
        JetSecondaryButton,
    },
    emits: [
        'attached',
    ],
    props: {
        availableUsers: Object,
        attachEndpoint: String,
    },
    computed: {
        filteredPeople() {
            return this.query === ''
                ? this.availableUsers
                : this.availableUsers.filter((person) => {
                    return person.name.toLowerCase().includes(this.query.toLowerCase()) || person.email.toLowerCase().includes(this.query.toLowerCase())
                })
        }
    },
    data() {
        return {
            selectedPerson: {},
            query: '',
            isProcessing: false,
        };
    },
    methods: {
        attachUser() {
            this.$inertia.post(this.attachEndpoint, {user_id: this.selectedPerson.id}, {
                preserveState: true,
                preserveScroll: true,
                onStart: () => {
                    this.isProcessing = true;
                },
                onFinish: () => {
                    this.selectedPerson = {};
                    this.isProcessing = false;
                }
            })
        }
    },
});
</script>

<style scoped>

</style>
